module.exports = __webpack_public_path__ + "images/event/event_avatar_default.dd59eb9f489a8dfec90a27697448dfe5.jpg";